<!-- Dialog Header -->
<h2 mat-dialog-title>Problem Encountered</h2>
<mat-dialog-content>
  <div (keyup.enter)="onKeyDown($event)">
    <table>
      <tr>
        <td style="color:#595959;">Date</td>
        <td style="padding-left:10px;">{{currentDate | date: 'MM/dd/yy h:mm a'}}</td>
      </tr>
      <tr>
        <td style="color:#595959;">User</td>
        <td style="padding-left:10px;">{{user}}</td>
      </tr>
      <tr>
        <td style="color:#595959;">URL</td>
        <td style="padding-left:10px;">{{fullPath}}</td>
      </tr>
      <tr>
        <td colspan="2" style="padding-top:15px;">
          Something unexpected has occurred and details have been logged.
        </td>
      </tr>
      <tr>
        <td colspan="2" style="padding-top:15px;font-weight:bold;">
          Please report this to your district SIS Coordinator or helpdesk.
        </td>
      </tr>
      <tr>
        <td colspan="6" #scoreInput id="txtScoreInput" (keydown)="onKeyDown($event)">
          <div *ngIf="showErrorDetails" style="overflow:scroll; border:gray; border-style:inset;border-width:thin; margin-top:10px; max-height:225px; max-width:580px; word-wrap:break-word">
            <div style="color:gray">Program</div>
            <div>{{programName}}</div>
            <br />
            <div style="color:gray">Message</div>
            <div>{{message}}</div>
            <br />
            <div style="color:gray">Stack Trace</div>
            <div>{{stackTrace}}</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<!-- Dialog Footer -->
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>